// extracted by mini-css-extract-plugin
export default {"summary-and-payment-espot__container":"summary-and-payment-espot__container_b5P23vZy"};